import React from 'react';
import { Table, message, Popconfirm, Button, Icon, Input, Select, Form, Modal, Row, Col,Tag,Badge,Card,Tree } from 'antd';
import {AxiosServer} from 'axios'
import {SET,GET} from '../../redux/actions/apiAction';
import {connect} from 'react-redux';
import FetchRender from './FetchRender';
import {ApiHelp} from '../../components';


const { TextArea } = Input;

function RenderBase({api,get,set}) {  

	//导入本组件所需参数变量
	const {data,apiHelpVisible} = api;	
	
	const onOk =(data)=>{
		
		let url = data.url;
		
		let body;
		try {
			body = eval('(' + data.dataFetchProps + ')')
			get({url,body}).then(res=>message.info(res))
		}catch(e){
			message.info(e.message)
		}
		
		
		
	}
	
	const ApiHelpProps = {			
		visible: apiHelpVisible,
		onOk (data) {		  
		  set({apiHelpVisible:false})	
		}, 			
		onCancel () {			
		  set({apiHelpVisible:false})		  
		},
	  }
	
	const btnShowApiHelp=()=>{		
		set({apiHelpVisible:true})		
	}
	
	const ModalApiHelpLoad = () => <ApiHelp {...ApiHelpProps}/>; 
	
	return (
		<div style={{ height:'85vh',margin: '-25px -15px -15px -15px',padding: 20,background: '#F1F3F4' }}>
			<Row gutter={16}>	
			
			<Col span ={24} >
			   <Row> 
				<Card title = '在线API调试' extra={<Button onClick={btnShowApiHelp}>说明</Button>}>					
					<FetchRender  onOk={onOk} />					
				</Card>
				</Row><br/>			   
			   <Row> <Card title = '返回结果'>
			   
			   <pre style={{ margin: 0, textAlign: 'left' }}>
                 {JSON.stringify(api.FetchData, null, 2)}<br/><br/>
                  </pre>
			  
			   
			   
			   </Card></Row><br/>
			   	
			</Col>
			
			</Row>
			{apiHelpVisible&&<ModalApiHelpLoad/>}
		</div>
	);
	
}

const mapStateToProps = (state) => {
  return {
    api: state.apiReducer
	}
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {  	
	set: (value)=>dispatch(SET(value)),
	get: (value)=>dispatch(GET(value)),

	}
}

const TestApi =connect(mapStateToProps,mapDispatchToProps)(RenderBase);

export default TestApi;
